import type { FairState, UnitStatus } from './schema';

export const ROUND_NAMES = ['סבב ראשון', 'סבב שני', 'סבב שלישי'] as const;

export const STATE_LABELS: Record<FairState, string> = {
  before: 'לפני היריד',
  keynote: 'התכנסות מרכזית',
  sessions: 'מפגשי היחידות',
  ended: 'היריד הסתיים',
};

export const STATE_IMPACT: Record<FairState, string> = {
  before: 'כפתור הוובינר וכפתורי המפגשים יינעלו. המידע על היחידות יישאר זמין לעיון.',
  keynote: 'כפתור הוובינר יופעל באתר. כפתורי המפגשים עם היחידות יישארו נעולים.',
  sessions: 'כפתורי Teams ייפתחו מיד בכל היחידות המפורסמות שיש להן קישור תקין.',
  ended: 'כפתורי הוובינר והמפגשים יינעלו. המידע על היחידות יישאר זמין לעיון.',
};

export const STATUS_LABELS: Record<UnitStatus, { text: string; tone: 'ok' | 'warn' | 'mute' }> = {
  published: { text: 'מפורסמת', tone: 'ok' },
  draft: { text: 'טיוטה', tone: 'warn' },
  hidden: { text: 'מוסתרת', tone: 'mute' },
};
